/* eslint-disable camelcase */
import common_tr from './tr/common.json';
import message_tr from './tr/message.json';

import common_en from './en/common.json';
import message_en from './en/message.json';


 const resources = {
  en: {
    common: common_en,
    message: message_en,
  },
  tr: {
    common: common_tr,
    message: message_tr,
  },
};

export default resources